import styled, { css } from 'styled-components'
import Spinner from 'builder/components/Spinner'
import Colors from 'builder/styles/colors'
import Media from 'builder/styles/media'
import Sizes from 'builder/styles/sizes'
import Typography, { FontWeights } from 'builder/styles/typography'
import whiteSpinner from './assets/white-spinner.png'
import spinner from './assets/spinner.png'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`
export const Table = styled.div`
  padding-top: ${Sizes.S};
  padding-bottom: ${Sizes.M};
  display: flex;
  gap: 2px;
  flex-direction: column;
  ${Typography.Caption}
`

export const Row = styled.div`
  display: flex;
  gap: 2px;
`

export const Cell = styled.div<{
  isTitle?: boolean
  color?: string
  bgColor?: string
  borderRadiusString?: string
}>`
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  align-items: center;
  justify-content: space-between;
  ${FontWeights.Regular}
  ${props =>
    props.isTitle &&
    css`
      ${FontWeights.Medium}
    `}

  color: ${props => (props.color ? props.color : Colors.Neutral90)};
  background-color: ${props => (props.bgColor ? props.bgColor : Colors.Neutral5)};
  ${props => props.borderRadiusString}
  padding: ${Sizes.S};
  ${Media.Phone`
    padding: ${Sizes.XS};
  `}
`

export const Img = styled.img`
  margin-bottom: -39px;
  margin-right: -20px;

  ${Media.Phone`
    display: none;
  `}
`

export const SlashedPrice = styled.span`
  color: #92cdfc;
  text-decoration: line-through;
`
export const DetailsContainer = styled.div`
  padding-top: ${Sizes.XS};
  display: flex;
  justify-content: center;
`

export const Details = styled.div`
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
  text-align: center;

  & span {
    ${FontWeights.DemiBold};
  }
`

export const PriceLoader = styled(Spinner)<{ type?: 'white' | 'default' }>`
  width: 24px;
  height: 24px;
  background-image: url(${({ type }) => (type === 'white' ? whiteSpinner : spinner)});
`
